import {take, fork, all, call, put} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import {surveyDetailSuccess, surveyDetailFailure} from '../actions/action_detail_survey';

function* watchOne() {
    while (true) {
        const {payload} = yield take(constants.SURVEY_DETAIL_REQUESTED);
        try {
            const response = yield call(api.fetchSurvey, payload.id);
            yield put(surveyDetailSuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(surveyDetailFailure(error));
        }
    }
}

export default function* root() {
    yield all([
        fork(watchOne),
    ]);
}
